import { Auditable, QueryParams, SortParams } from "..";

export interface ProcedureType extends Auditable {
    name: string;
    qboItemId?: string;
}

export const DefaultProcedureTypeQueryParams: QueryParams = {
    name: "",
};

export const DefaultProcedureTypeSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};

// compare to microservice/Resources/ProcedureTypes/DefaultProcedureTypes.cs

export enum ProcedureTypes {
    AsgCornea = "ASG Cornea (Glycerol)",
    CAIRS = "CAIRS",
    LabCornealExcision = "Laboratory Corneal Excision",
    DMEKStandard = "DMEK: Standard (Hinge/Center Attachment)",
    DMEKPreloaded = "DMEK: Preloaded",
    DMEKPatientReady = "DMEK: Patient Ready",
    MicrokeratomeDSAEK = "Microkeratome Processed: DSAEK",
    MicrokeratomeDSAEKPreloaded = "Microkeratome Processed: DSAEK Preloaded",
    MicrokeratomeDSAEKTrephined = "Microkeratome Processed: DSAEK Trephined",
    MicrokeratomeALK = "Microkeratome Processed: ALK",
    MicrokeratomeLenticule = "Microkeratome Processed: Lenticule",
    ScleraPreservationWhole = "Sclera Preservation (Whole)",
    ScleraPreservationHalf = "Sclera Preservation (Half)",
    ScleraPreservationQuarter = "Sclera Preservation (Quarter)",
    TissueTransferAntifungal = "Tissue Transfer: Antifungal",
    TissueTransferSection = "Tissue Transfer: Section",
    TissueTransferOther = "Tissue Transfer: Other",
}

export const microkeratomeProcedures: string[] = [
    ProcedureTypes.MicrokeratomeDSAEK,
    ProcedureTypes.MicrokeratomeDSAEKPreloaded,
    ProcedureTypes.MicrokeratomeDSAEKTrephined,
    ProcedureTypes.MicrokeratomeALK,
    ProcedureTypes.MicrokeratomeLenticule,
];

export const isMicrokeratome = (procedureType: string | undefined) =>
    microkeratomeProcedures.includes(procedureType ?? "");

export const dmekProcedures: string[] = [
    ProcedureTypes.DMEKStandard,
    ProcedureTypes.DMEKPreloaded,
    ProcedureTypes.DMEKPatientReady,
];

export const isDMEK = (procedureType: string | undefined) => dmekProcedures.includes(procedureType ?? "");
